import merge from 'lodash/merge'
import * as ActionTypes from 'actions/modals'

// import {
//   MODAL_CREATE,
//   MODAL_HIDE,
//   MODAL_SHOW,
// } from 'actions/modals'

const initialState = {
  _isShowing: false,
}

export default function modals(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.MODAL_CREATE:
      return merge({}, state, {
        [action.id]: {
          show: false,
        },
      })
    case ActionTypes.MODAL_HIDE: {
      let isShowing = -1
      Object.keys(state).forEach((key) => {
        isShowing += (state[key].show) ? 1 : 0
      })
      isShowing = (isShowing > 0)

      return merge({}, state, {
        _isShowing: isShowing,
        [action.id]: {
          show: false,
        },
      })
    }
    case ActionTypes.MODAL_SHOW:
      return merge({}, state, {
        _isShowing: true,
        [action.id]: {
          show: true,
        },
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modals.js